import { CANVAS_WIDTH } from '@constants/canvas/general';

export type CanvasSize = {
  canvasWidth: number;
  containerHeight: number;
};

const initial: CanvasSize = {
  canvasWidth: CANVAS_WIDTH,
  containerHeight: 0,
};

let snapshot: CanvasSize = initial;
let observer: ResizeObserver | null = null;
let observed: Element | null = null;

const listeners = new Set<() => void>();

export const getCanvasSize = () => snapshot;

const setCanvasSize = (next: CanvasSize) => {
  if (
    next.canvasWidth === snapshot.canvasWidth &&
    next.containerHeight === snapshot.containerHeight
  ) {
    return;
  }

  snapshot = next;
  listeners.forEach((listener) => listener());
};

/**
 * Subscribes to the size of `#canvas`. All consumers share a single
 * ResizeObserver, and the snapshot only changes identity when a dimension
 * actually changes, so subscribers can bail out of unchanged renders.
 */
export const subscribeToCanvasSize = (listener: () => void) => {
  listeners.add(listener);

  const element = document.querySelector('#canvas');

  if (element && observed !== element) {
    observer?.disconnect();
    observed = element;

    observer = new ResizeObserver((entries) => {
      const { width, height } = entries[0].contentRect;

      setCanvasSize({
        canvasWidth: width || CANVAS_WIDTH,
        containerHeight: height,
      });
    });

    observer.observe(element);
  }

  return () => {
    listeners.delete(listener);

    if (listeners.size === 0) {
      observer?.disconnect();
      observer = null;
      observed = null;
    }
  };
};
